import {makeStyles, Typography} from "@material-ui/core";
import React, {useEffect, useRef, useState} from 'react';
import Cube from "../../../Domain/Models/Cube";
import CubeElement from "./CubeElement";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  element: {
    marginBottom: '20px',
  },
}));

export enum CubeColumn
{
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
}

export interface CubeElementsListProps
{
  cubes: Cube[];
  cubeColumn : CubeColumn;
}

export default function CubeElementsList(props: CubeElementsListProps)
{
  const classes = useStyles();
  const {cubes, cubeColumn} = props;
  
  return (
    <>
      {cubes.map((x, i) => (
        <div className={classes.element} >
          <CubeElement cube={x} cubeColumn={cubeColumn} index={i} />
        </div>
      ))}
    </>
  )
}